var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"chart"}},[_c('table-stats',{on:{"load-data":_vm.loadData}}),_c('thermometer-stats',{on:{"load-data":_vm.loadData}}),_c('evolution-stats',{on:{"load-data":_vm.loadData}}),_c('calification-stats',{on:{"load-data":_vm.loadData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }